import { render, staticRenderFns } from "./Fares.vue?vue&type=template&id=4da83a01&scoped=true&"
import script from "./Fares.vue?vue&type=script&lang=js&"
export * from "./Fares.vue?vue&type=script&lang=js&"
import style0 from "./Fares.vue?vue&type=style&index=0&id=4da83a01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da83a01",
  null
  
)

export default component.exports